import React from "react";
import { NavLink } from "react-router-dom";
import { HiUserGroup } from "react-icons/hi";

const VfsBranchSidebar = () => {

  return (
    <div className="lg:flex flex-no-wrap min-h-[91.8vh] hidden">
      <div className="min-w-[230px] bg-white  flex-col justify-between flex">
        <div>
          <ul className="px-3 py-5 flex flex-col gap-2 min-w-[231px]">
          <li>
              <NavLink
                to="/vfs-branch/member"
                className="flex items-center gap-3 px-[12px] font-Roboto text-lg text-[#1A1A1A] py-3"
              >
                <HiUserGroup /> Member List
              </NavLink>
            </li>
          
          </ul>
        </div>
      </div>
    </div>
  );
};

export default VfsBranchSidebar;
